export default __webpack_public_path__ + "static/media/gallery_01.4aa185f7.jpg";